module.exports = __webpack_public_path__ + "448c34a56d699c29117adc64c43affeb.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/glyphicons/glyphicons-webfont.woff2
 ** module id = ./src/styles/fonts/glyphicons/glyphicons-webfont.woff2
 ** module chunks = 0
 **/